// Até 12 colunas cabem em retrato com fonte menor; acima disso o documento inteiro vai para
// paisagem (orientações diferentes quebrariam a página antes e depois da tabela).
export type ProposalPageOrientation = 'portrait' | 'landscape';

export interface ProposalTableLayout {
  orientation: ProposalPageOrientation;
  fontPt: number;
}

export const tableLayout = (totalColunas: number): ProposalTableLayout => {
  if (totalColunas <= 10) return { orientation: 'portrait', fontPt: 8 };
  if (totalColunas <= 12) return { orientation: 'portrait', fontPt: 7 };
  if (totalColunas <= 16) return { orientation: 'landscape', fontPt: 7 };
  return { orientation: 'landscape', fontPt: 6 };
};

// Deixa o navegador pintar o "Gerando…" antes da montagem pesada do arquivo (propostas grandes).
export const yieldToBrowser = () =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, 0);
  });
